import { Button, Col, Form, Input, Popconfirm, Row, Select, message } from "antd";
import DatePicker from "../../../../../components/inputs/MomentDatePicker";
import axios from "axios";
import * as moment from "moment";
import React, { useEffect } from "react";
import { useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { serverUrl } from "../../../../../nestserver";

function ClassSetting({ classDetails }) {
  const { Option } = Select;
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  // fetch the school's current default class dates
  async function fetchDefaultDates() {
    const res = await axios.get(serverUrl + "/classes/default-dates", {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });
    return res.data;
  }
  const defaultDatesQuery = useQuery("classDefaultDates", fetchDefaultDates);
  const defaultDates = defaultDatesQuery.data;

  // fetch Instructors
  async function fetchInstructors() {
    const res = await axios({
      method: "get",
      url: serverUrl + "/users/",
      params: {
        role: "instructor",
      },
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    });

    return res.data;
  }
  const instructors = useQuery("instructors", fetchInstructors);

  // update class
  function updateClass(values) {
    axios
      .patch(serverUrl + "/classes/" + classDetails?._id, values, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      })
      .then((res) => {
        message.success("Class Updated");
        queryClient.invalidateQueries("classes");
        queryClient.invalidateQueries(["class", classDetails?._id]);
      })
      .catch((error) => {
        if (error?.response?.data) {
          message.error(error?.response?.data.message);
        } else {
          message.error(error.message);
        }
      });
  }

  // delete class
  function deleteClass() {
    axios
      .delete(serverUrl + "/classes/" + classDetails?._id, {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
        },
      })
      .then((res) => {
        message.success("Class Deleted");
        queryClient.invalidateQueries("classes");
        queryClient.invalidateQueries(["class", classDetails?._id]);
        navigate("/dashboard/admin/menu/class");
      });
  }

  // Keep the class's academic/transition dates in sync with the school's
  // current default dates (set in School Settings), so editing a class
  // picks up whatever was most recently configured there.
  useEffect(() => {
    if (defaultDates) {
      form.setFieldsValue({
        academic_start_date: defaultDates.academic_start_date
          ? moment(defaultDates.academic_start_date)
          : undefined,
        academic_end_date: defaultDates.academic_end_date
          ? moment(defaultDates.academic_end_date)
          : undefined,
        transition_start_date: defaultDates.transition_start_date
          ? moment(defaultDates.transition_start_date)
          : undefined,
        transition_end_date: defaultDates.transition_end_date
          ? moment(defaultDates.transition_end_date)
          : undefined,
      });
    }
  }, [defaultDates, form]);

  // action: "" (first-time generate) | "assign-missing" | "regenerate"
  const generateRollNumber = (classId, action = "") => {
    if (classId) {
      axios
        .post(
          serverUrl +
            "/students/roll-number/class/" +
            classId +
            (action ? "/" + action : ""),
          {},
          {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem(
                "jwt-token"
              )}`,
            },
          }
        )
        .then((res) => {
          queryClient.invalidateQueries(["class", classDetails?._id]);
          message.success(res?.data?.result?.message);
        })
        .catch((err) => {
          message.error(err?.response?.data?.error?.errors);
        });
    }
  };

  return (
    <>
      <div className="pt-8">
        <div
          style={{ borderRadius: "10px", color: "#616161" }}
          className=" bg-white drop-shadow-md p-8 w-full "
        >
          {classDetails && (
            <Form
              form={form}
              layout="vertical"
              name="basic"
              initialValues={{
                name: classDetails?.name,
                subjects: classDetails?.subjects?.map((s) => s._id),
                in_charge: classDetails?.in_charge?._id,
              }}
              onFinish={updateClass}
            >
              <div className="md:w-3/4">
                <Form.Item
                  label="Class Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      message: "Please input class name",
                    },
                  ]}
                >
                  <Input className="w-full" />
                </Form.Item>

                <Form.Item label="Class In Charge" name="in_charge">
                  <Select allowClear placeholder="Please select">
                    {instructors?.isSuccess
                      ? instructors?.data
                          ?.filter((t) => !t.blocked)
                          ?.map((i) => (
                            <Option key={i?._id} value={i?._id}>
                              {i?.teacher?.first_name} {i?.teacher?.last_name}
                            </Option>
                          ))
                      : []}
                  </Select>
                </Form.Item>

                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Academic Start Date"
                      name="academic_start_date"
                    >
                      <DatePicker
                        className="w-full"
                        disabled
                        format="DD/MM/YYYY"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Academic End Date" name="academic_end_date">
                      <DatePicker
                        className="w-full"
                        disabled
                        format="DD/MM/YYYY"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Transition Start Date"
                      name="transition_start_date"
                      tooltip="Transistion period is the phase where Instructor/Admin can complete the Evalauations and Transfers to the next class"
                    >
                      <DatePicker
                        className="w-full"
                        disabled
                        format="DD/MM/YYYY"
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Transition End Date"
                      name="transition_end_date"
                      tooltip="Transistion period is the phase where Instructor/Admin can complete the Evalauations and Transfers to the next class"
                    >
                      <DatePicker
                        className="w-full"
                        disabled
                        format="DD/MM/YYYY"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </div>

              <div>
                {classDetails?.is_roll_number_generated ? (
                  <div className="flex flex-row space-x-4">
                    <Button
                      onClick={() =>
                        generateRollNumber(classDetails?._id, "assign-missing")
                      }
                    >
                      Assign Roll Number to New Students
                    </Button>
                    <Popconfirm
                      title="This renumbers every student in the class from 1. Continue?"
                      onConfirm={() =>
                        generateRollNumber(classDetails?._id, "regenerate")
                      }
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button>Regenerate All Roll Numbers</Button>
                    </Popconfirm>
                  </div>
                ) : (
                  <Button onClick={() => generateRollNumber(classDetails?._id)}>
                    Generate Roll Number
                  </Button>
                )}
              </div>
              <div className="flex items-center justify-between pt-10 ">
                <div>
                  <Popconfirm
                    title="Are you sure to delete this class?"
                    onConfirm={deleteClass}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button size="large" type="danger">
                      Delete Class
                    </Button>
                  </Popconfirm>
                </div>
                <div className="flex flex-row space-x-4">
                  <Button
                    size="large"
                    type="dark"
                    onClick={() => form?.resetFields()}
                  >
                    Cancel
                  </Button>

                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className="text-white"
                  >
                    Save Changes
                  </Button>
                </div>
              </div>
            </Form>
          )}
        </div>
      </div>
    </>
  );
}

export default ClassSetting;
